export default __webpack_public_path__ + "static/media/la_capelle7.0106038c.jpg";